<template>
    <div v-if="article.article_languages[0] != null" class="item-row" :dir="$store.state.language.code === 'ar' ? 'rtl' : 'ltr'">
        <figure class="img-scale-in trans fade-scale-trans delay-2">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a>
            <div class="figcaptionrow">
                <a v-if="$store.state.language.code !== 'ar'" :href="$store.state.hrefPrefix + '/category/' + article.category.slug"><span>{{article.category.category_languages[0].pivot.name}}</span></a>
                <figcaption>
                    <h2><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h2>
                </figcaption>
            </div>
        </figure>
    </div>
</template>

<script>
export default {
    name: 'SliderArticle',
    props: {
        article: {
            type: Object,
            default: null
        },
    }
}
</script>

<style scoped>

</style>
